import React, { useEffect, useState, useContext } from "react";
import moengage from "@moengage/web-sdk";
// import { useHistory, useLocation } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import {
  GetCustomerDetailsContext,
  GetCustomerDetails,
  validateInputExistenece,
} from "../../App";
import {
  DIGISIGN,
  GET_ALL_DOCS,
  LMS_LOAN_DISBURSAL_A3S,
  LMS_LOAN_DISBURSAL_FINNONE,
  SEND_OTP,
  VERIFY_OTP,
  UPDATE_DYNAMO_DB,
} from "../../Config";
import Icon_Agreement_form from "../../assets/svg/EPL_think_svg/Icon_Agreement_form.svg";
import Pdf_icon from "../../assets/svg/EPL_think_svg/Pdf_icon.svg";
import timer from "../../assets/svg/EPL_think_svg/timer.svg";
import OTPInput from "../../components/base/OtpInput.js";
import Button from "../../components/core/EPL_Button_Think";
import SubTitle from "../../components/core/SubTitle";
import Title from "../../components/core/Title";
import CheckField from "../../components/form/CheckField";
import ProgressBar from "../../components/navigation/progress_bar/EPL_ProgressBar";
import ShimmerPlaceholder from "../../components/placeholders/ShimmerPlaceholder";
import useMediaQuery from "../../hooks/useMediaQuery";
import { getRouteFromLoanStageService } from "../../shared/services/getRouteFromLoanStageService";
import { isValidOTP } from "../../shared/validations/OTP";
import { encrypt } from "../../utils/crypto";
import sendRequest from "../../utils/sendRequest";
import { AfterLoginLayoutWrapper } from "../_styles/EPL_AfterLoginLayoutWrapper_think";
import {
  IncorrectOtpModal,
  MaxOtpRetryModal,
  MaxVerifyOtpRetryModal,
  OtpExpiredModal,
  ResendOtpModal,
  CheckInternetModal,
} from "../other-pages/Modals/AllModal";
import LoanSummaryTextItem from "./_styles/EPL_LoanSummaryTextItem";
import Modal from "./_styles/EPL_Modal";
import Text from "./_styles/EPL_Text.js";
import { LoanAgreementWrapper } from "./_styles/LoanAgreementWrapper";
import PdfModal from "../../modals/PdfModal.js";
import { updateLead } from "../../shared/services/crm";
import { isStageLogin } from "../../shared/validations/StageLogin.js";
import { userConsentStatus } from "../../utils/userConsentStatus.js";
import { encryptedData } from "../../utils/index.js";
moengage.initialize({app_id: 'L9SUGRVWTLEJA9UWH2ZEAMHL', cluster: 'dc_3'});

const LoanAgreement = () => {
  // const history = useHistory();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("screen and (max-width: 768px)");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [totalLoanAmount, setTotalLoanAmount] = useState(Number(170000));
  const [emiAmount, setEmiAmount] = useState(Number(29000));
  const [processingFee, setProcessingFee] = useState(Number(1000));
  const [insuranceAmount, setInsuranceAmount] = useState(Number(1500));
  const [tenure, setTenure] = useState(12);
  const otpWaitTime = "00:10";
  const [interestRate, setInterestRate] = useState(12);
  const [showEmailOTPModal, setShowEmailOTPModal] = useState();
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [enableResendOtp, SetEnableResendOtp] = useState(false);
  const [seconds, setSeconds] = useState();
  const [minutes, setMinutes] = useState();
  const [load, setLoad] = useState();
  const [otpDigits, setOtpDigits] = useState(Array(6).fill(""));
  const [otp, setOtp] = useState("");
  const [modal, setModal] = useState("");
  const [resendOtpButtonDisabled, setResendOtpButtonDisabled] = useState(true);
  const [resendOtp, setResendOtp] = useState(false);
  const [KFS, setKFS] = useState("");
  const [SanctionLetter, setSanctionLetter] = useState("");
  const [Agreement, setAgreement] = useState("");

  const [mobNum, setMobNum] = useState("");
  const [showOtpExpiredModal, setShowOtpExpiredModal] = useState(false);
  const [showMaxRetryModal, setShowMaxRetryModal] = useState(false);
  const [showVerifyMaxRetryModal, setShowVerifyMaxRetryModal] = useState(false);
  const [ischecked, setIsChecked] = useState(false);
  const [internetCheck, setInternetCheck] = useState(false);
  const [isOtpwrong, SetIsOtpWrong] = useState(false);
  // const [customerDetails, setCustomerDetails] = useState(
  //   location?.state?.customerDetails
  // );
  const [customerDetails, setCustomerDetails] = useContext(
    GetCustomerDetailsContext
  );
  const [showShimmer, setShowShimmer] = useState(false);
  const [kfsIframeModal, setKfsIframeModal] = useState(false);
  const [kfsIframeUrl, setKfsIframeUrl] = useState(null);
  const source = location.pathname.split("/")[1];
  const [tncAcceptConsent, setTncAcceptConsent] = useState(false)

  useEffect(async () => {
    // if(validateInputExistenece(customerDetails) && validateInputExistenece(customerDetails["stage"])) {
    if (validateInputExistenece(customerDetails)) {
      // console.log("LoanAgreement customerDetails: ", customerDetails);
      setShowShimmer(false);
      // TODO: Handle Staging if needed
      // navigate("/details", {
      //   replace: true,
      //   state: {
      //     customerDetails: customerDetails,
      //   },
      // });
    }
    if (
      validateInputExistenece(customerDetails) &&
      validateInputExistenece(customerDetails["stage"])
    ) {
      // console.log("00 - stage: ", customerDetails.stage);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: customerDetails.stage,
      });
      // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      if (customerDetails?.Data?.isError === "True") {
        // console.log(">>>><<<<<<<<<<");
        if (parseInt(customerDetails?.Data?.retry_count) > 0) {
          console.log("<<<<<>>>>>>>>>>>>>>>>>");
          if (customerDetails?.Data?.api_name === "getAllDocuments") {
            console.log(
              ">>>>>>>>>>>>>>>><<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<"
            );
            await getAllDocs();
          }
          if (customerDetails?.Data?.api_name === "updateDynamodb") {
            console.log("here");
            updateDynamoDB();
          }
          if (customerDetails?.Data?.api_name === "lmsLoanDisbursalAsyncA3S") {
            await LmsLoanDisbursalA3s();
          }
          // if (
          //   customerDetails?.Data?.api_name === "lmsLoanDisbursalAsyncFinnone"
          // ) {
          //   LmsLoanDisbursalFinnone();
          // }
        } else {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          // // console.log("stage: ", customerDetails.stage);
          // console.log("route: ", route);
          navigate(`${route}`, {
            replace: true,
          });
        }
      } else {
        navigate(`${route}`, {
          replace: true,
          state: {
            customerDetails: customerDetails,
          },
        });
      }
    } else {
      // console.log("LoanAgreement Ouch customerDetails ", location);
    }
    // console.log("Called GetCustomerDetails --- agreement");
    // console.log(customerDetails);
  }, [customerDetails]);

  // useEffect(async () => {
  //   await GetCustomerDetails(
  //     customerDetails.application_form_number,
  //     customerDetails.source,
  //     customerDetails,
  //     setCustomerDetails
  //   );
  //   console.log("Called GetCustomerDetails --- agreement");
  //   console.log(customerDetails);
  // }, []);

  useEffect(() => {
    var otpString = otpDigits.join("");
    if (isValidOTP(otpString)) {
      setIsOtpValid(true);
      setOtp(otpString);
    } else {
      setIsOtpValid(false);
    }
  }, [otpDigits]);

  function downloadPDF(pdfData, pdfFileName) {
    fetch(pdfData)
      .then((response) => response.blob()) // Convert the response to a blob
      .then((blob) => {
        const downloadLink = document.createElement("a");
        const fileName = pdfFileName + ".pdf";
        const url = URL.createObjectURL(blob);

        downloadLink.href = url;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink); // Append the link to the document
        downloadLink.click(); // Trigger the download
        document.body.removeChild(downloadLink); // Remove the link
        URL.revokeObjectURL(url); // Release the object URL
      })
      .catch((error) => {
        console.error("Error downloading the PDF: ", error);
      });
  }

  const openPDFiFrame = (pdfType) => {
    if (sessionStorage.getItem("mobileApplication") === "TRUE") {
      console.log(pdfType);
    } else {
      var fileName = "";
      if (pdfType == "KFS") {
        // setiFrameUrl(KFS);
        fileName = "KFS_Document";
        downloadPDF(KFS, fileName);
      } else if (pdfType == "Sanction_Letter") {
        // setiFrameUrl(SanctionLetter);
        fileName = "Sanction_Letter_Document";
        downloadPDF(SanctionLetter, fileName);
      } else if (pdfType == "Agreement") {
        // setiFrameUrl(Agreement);
        fileName = "Agreement_Document";
        downloadPDF(Agreement, fileName);
      }
    }
    // // console.log("iFrameUrl-", iFrameUrl);
  };

  const resetOTP = async () => {
    const newOtpDigits = [...otpDigits];
    for (let i = 0; i < 6; i++) {
      newOtpDigits[i] = "";
    }
    setOtpDigits(newOtpDigits);
  };

  const handleCheckBox = async () => {
    setTncAcceptConsent(!tncAcceptConsent)
    setIsChecked(!ischecked);
    // console.log("checkBox clicked");
  };

  function appendRupee(x) {
    const converted = new Intl.NumberFormat("en-IN", {
      maximumSignificantDigits: 21,
      style: "currency",
      currency: "INR",
    }).format(x);
    return converted;
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
          SetEnableResendOtp(true);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const [totalLoanAmountCheck, setTotalLoanAmountCheck] = useState();
  useEffect(async () => {
    // console.log("HERE");

    isStageLogin(
      customerDetails?.Data?.uuid,
      customerDetails?.Data?.mobile,
      customerDetails?.source,
    );
    if (customerDetails?.Data?.isError !== "True") {
      await getAllDocs();
      setTotalLoanAmountCheck(
        parseInt(
          customerDetails?.Data?.cust_accepted_loan_amount +
            customerDetails?.Data?.old_loan_amount
        )
      );
    }
    // window.scrollTo(0, 0);
  }, []);

  const getAllDocs = async () => {
    try {
      setShowShimmer(true);
      // console.log("getALlDocs: inside try block");
      // console.log(customerDetails?.application_form_number);
      const formData = new FormData();
      const requestData = {
        application_form_no: customerDetails.application_form_number,
      };
      formData.append("data", encryptedData(requestData));
      const response = await sendRequest(
        "/" + customerDetails.source + GET_ALL_DOCS,
        formData
      );
      // setShowShimmer(false);

      // console.log("getALlDocs: response => ", response);

      if (response.response.Success === true) {
        setShowShimmer(false);
        // something
        const kfsUrl = response.response.Data.KFS;
        // Check if the KFS URL is valid before setting it
        if (kfsUrl && typeof kfsUrl === 'string' && kfsUrl.trim() !== '') {
            setKfsIframeUrl(kfsUrl);
            setKfsIframeModal(true);
        } else {
            console.error('Invalid KFS URL:', kfsUrl);
        }
        setKFS(`${response.response.Data.KFS}`);
        setSanctionLetter(
          `${response.response.Data.SANCTION_LETTER}`
        );
        setAgreement(
          `${response.response.Data.LOAN_AGREEMENT}`
        );
      }
    } catch (error) {
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          75,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          75,
          customerDetails.application_form_number
        );
      }
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
        // // console.log("stage: ", customerDetails.stage);
        // console.log("route: ", route);
        navigate(`${route}`, {
          replace: true,
        });
        // setShowShimmer(false);
        // console.log("getALlDocs: inside catch block");
      }
    }
  };

  const digiSign = async () => {
    var payload = {
      application_form_no: customerDetails?.application_form_number,
    };
    // console.log(payload);
    try {
      setShowShimmer(true);
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + customerDetails.source + DIGISIGN,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        // console.log(response.response.STAGE);
        setShowShimmer(false);
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
      }
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          75,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          75,
          customerDetails.application_form_number
        );
      }
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      // navigate(`${route}`, {
      //   replace: true,
      // });
    }
  };

  const sendOtp = async () => {
    var payload = {
      mobile_number: customerDetails?.Data.mobile,
      mode: "AGREEMENT",
    };
    // console.log(payload);
    try {
      setShowShimmer(true);
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + customerDetails.source + SEND_OTP,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        // console.log("Otp sent");
        setShowShimmer(false);
        setIsOtpSent(false);
        setResendOtp(true);
        setMinutes(0);
        setSeconds(10);
      }
      if (response.response.ErrorType == "OTP_MAX_RETRY") {
        // console.log("Maximum retry reached");
        setIsOtpSent(false);
        setShowMaxRetryModal(true);
        setShowShimmer(false);
      }
    } catch (error) {
      if (error.message === "API call cancelled due to connectivity issue") {
        setInternetCheck(true);
      } else {
        if (customerDetails.source === "upsell") {
          updateLead(
            customerDetails.source,
            75,
            customerDetails.application_form_number
          );
        } else {
          updateLead(
            customerDetails.source,
            75,
            customerDetails.application_form_number
          );
        }
        if (error === "Unauthorised") {
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "",
          });
          navigate(`${route}`, {
            replace: true,
          });
        } else {
          console.error(`Unknown Error: Constants Not Retireved - ${error}`);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          navigate(`${route}`, {
            replace: true,
          });
        }
      }
    }
  };

  const verifyOTP = async () => {
    if (isOtpValid) {
      var payload = {
        mobile_number: customerDetails?.Data.mobile,
        otp: otp,
        mode: "AGREEMENT",
      };
      setIsOtpSent(false);
      try {
        const formData = new FormData();
        formData.append("data", encryptedData(payload));
        // setCustomerDetails({
        //   ...customerDetails,
        //   stage: "DISBURSED_START",
        // });
        // console.log("2- LOG - stage: ", customerDetails.stage);
        const response = await sendRequest(
          "/" + customerDetails.source + VERIFY_OTP,
          formData
        );
        // console.log("Response: ", response);
        if (response.response.ErrorType == "INVALID_OTP") {
          // console.log("incorrect");
          setIsOtpSent(false);
          SetIsOtpWrong(true);
        }
        if (response.response.ErrorType == "OTP_EXPIRED") {
          setIsOtpSent(false);
          setShowOtpExpiredModal(true);
        }
        if (response.response.ErrorType == "OTP_MAX_RETRY") {
          setShowVerifyMaxRetryModal(true);
          setShowShimmer(false);
        }
        if (response.response.Success) {
          moengage.track_event("agreement_form", {
            "journey name": customerDetails.source,
            eConsent_given: "yes",
          })
          // console.log("Otp Verified");
          setShowShimmer(true);
          if (source === "epl") {
            // console.log("LmsLoanDisbursalA3s called");
            // LmsLoanDisbursalA3s();
            updateDynamoDB();
          } else if (source === "upsell") {
            // console.log("3- LOG - stage: ", customerDetails.stage);
            LmsLoanDisbursalFinnone();
          }
        }
      } catch (error) {
        if (error.message === "API call cancelled due to connectivity issue") {
          setInternetCheck(true);
        } else {
          if (error === "Unauthorised") {
            var route = getRouteFromLoanStageService({
              source: customerDetails.source,
              stage: "",
            });
            navigate(`${route}`, {
              replace: true,
            });
          }
          if (customerDetails.source === "upsell") {
            updateLead(
              customerDetails.source,
              75,
              customerDetails.application_form_number
            );
          } else {
            updateLead(
              customerDetails.source,
              75,
              customerDetails.application_form_number
            );
          }
          console.error(`Unknown Error: Constants Not Retireved - ${error}`);
          var route = getRouteFromLoanStageService({
            source: customerDetails.source,
            stage: "error",
          });
          navigate(`${route}`, {
            replace: true,
          });
        }
        // var route = getRouteFromLoanStageService({
        //   source: customerDetails.source,
        //   stage: "error",
        // });
        // // console.log("stage: ", customerDetails.stage);
        // // console.log("route: ", route);
        // navigate(`${route}`, {
        //   replace: true,
        // });
      }
    }
  };

  const updateDynamoDB = async () => {
    var payload = {
      application_form_no: customerDetails?.application_form_number,
    };
    // console.log(payload);
    try {
      setShowShimmer(true);
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + customerDetails.source + UPDATE_DYNAMO_DB,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        await LmsLoanDisbursalA3s();
      } else if (response.response.STAGE === "DISBURSEMENT_REVERIFY") {
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
      }
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const LmsLoanDisbursalA3s = async () => {
    var payload = {
      application_form_no: customerDetails?.application_form_number,
      current_stage: customerDetails.stage,
    };
    // console.log(payload);
    try {
      setShowShimmer(true);
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + customerDetails.source + LMS_LOAN_DISBURSAL_A3S,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.Success) {
        await digiSign();
        updateLead(
          customerDetails.source,
          62,
          customerDetails.application_form_number
        );
        // console.log("4 - stage: ", response.response.STAGE);
        // // console.log(response.response.STAGE);
        setShowShimmer(false);
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
      }
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const LmsLoanDisbursalFinnone = async () => {
    // console.log(customerDetails);
    // console.log("STAGE >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>.",customerDetails.stage);
    var payload = {
      application_form_no: customerDetails?.application_form_number,
      // current_stage: customerDetails.stage,
    };
    // console.log(payload);
    try {
      setShowShimmer(true);
      const formData = new FormData();
      formData.append("data", encryptedData(payload));
      const response = await sendRequest(
        "/" + customerDetails.source + LMS_LOAN_DISBURSAL_FINNONE,
        formData
      );
      // console.log("Response: ", response);
      if (response.response.STAGE === "DISBURSEMENT_REVERIFY") {
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      }
      if (response.response.Success) {
        await digiSign();
        updateLead(
          customerDetails.source,
          62,
          customerDetails.application_form_number
        );
        // console.log("6 - stage: ", response.response.STAGE);
        setShowShimmer(false);
        setCustomerDetails({
          ...customerDetails,
          stage: response.response.STAGE,
        });
      } else {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "error",
        });
      }
    } catch (error) {
      if (error === "Unauthorised") {
        var route = getRouteFromLoanStageService({
          source: customerDetails.source,
          stage: "",
        });
        navigate(`${route}`, {
          replace: true,
        });
      }
      if (customerDetails.source === "upsell") {
        updateLead(
          customerDetails.source,
          76,
          customerDetails.application_form_number
        );
      } else {
        updateLead(
          customerDetails.source,
          76,
          customerDetails.application_form_number
        );
      }
      console.error(`Unknown Error: Constants Not Retireved - ${error}`);
      var route = getRouteFromLoanStageService({
        source: customerDetails.source,
        stage: "error",
      });
      // // console.log("stage: ", customerDetails.stage);
      // console.log("route: ", route);
      navigate(`${route}`, {
        replace: true,
      });
    }
  };

  const handleVerifyOTPClick = async ()=>{
    const payload = {
      agreement_acceptance_of_tnc: tncAcceptConsent,
    }
    const src = customerDetails.source;
    await userConsentStatus(payload , src);
    await verifyOTP();
  }

  return (
    <>
      <ProgressBar showProgress={true} currentStep={6} />
      <AfterLoginLayoutWrapper>
        <PdfModal isOpen={kfsIframeModal} url={kfsIframeUrl} onOk={() => {
          setKfsIframeModal(false)
        }} />
        <CheckInternetModal
          isOpen={internetCheck}
          onClose={() => {
            setInternetCheck(false);
            setShowShimmer(false);
          }}
        />
        <MaxOtpRetryModal
          isOpen={showMaxRetryModal}
          onClose={() => {
            setShowMaxRetryModal(false);
            setIsOtpSent(true);
            SetEnableResendOtp(false);
            setResendOtp(false);
            setMinutes(15);
            setSeconds(1);
            resetOTP();
          }}
        />
        <MaxVerifyOtpRetryModal
          isOpen={showVerifyMaxRetryModal}
          onClose={() => {
            setShowVerifyMaxRetryModal(false);
            setIsOtpSent(false);
          }}
        />
        <OtpExpiredModal
          isOpen={showOtpExpiredModal}
          onClose={() => {
            setShowOtpExpiredModal(false);
            setIsOtpSent(true);
            resetOTP();
          }}
        />
        <ResendOtpModal
          mobileNumber={customerDetails?.Data?.mobile?.slice(6, 10)}
          isOpen={resendOtp}
          onClose={() => {
            setResendOtp(false);
            setIsOtpSent(true);
            SetEnableResendOtp(false);
            setSeconds(10);
            resetOTP();
          }}
        />
        <IncorrectOtpModal
          isOpen={isOtpwrong}
          onClose={() => {
            SetIsOtpWrong(false);
            setIsOtpSent(true);
            SetEnableResendOtp(false);
            setResendOtp(false);
            setSeconds(10);
            resetOTP();
          }}
        />
        <LoanAgreementWrapper
          className="first-child"
          style={{
            padding: isMobile ? "0rem 0rem 0rem 0rem" : "",
            maxWidth: isMobile ? "" : "60rem",
          }}
        >
          <div className="progress-bar-container"></div>
          <div id="login-form">
            <div id="login-greetings">
              <ShimmerPlaceholder
                height="2.5em"
                marginTop="1em"
                width="12em"
                visible={showShimmer}
              />
              <div className="pageTitle">
                <Title
                  text={`Agreement Form`}
                  visible={!showShimmer}
                  clickable={false}
                  icon={
                    <>
                      <img
                        src={Icon_Agreement_form}
                        alt="titleIcon.svg"
                        height="20"
                        width="20"
                      />
                    </>
                  }
                />
              </div>
              <div className="pageSubTitle">
                <ShimmerPlaceholder
                  height="3.5em"
                  marginTop="-0.5em"
                  visible={showShimmer}
                />
                <SubTitle
                  text={`Please go through the Loan Agreement and accept the Terms and Conditions to proceed`}
                  visible={!showShimmer}
                  clickable={false}
                />
              </div>
            </div>

            <div>
              {showShimmer ? (
                <>
                  <ShimmerPlaceholder
                    height="11em"
                    width="21em"
                    visible={showShimmer}
                  />
                </>
              ) : (
                <>
                  <div className="agreementBox">
                    <div className="boxContent">
                      <Text
                        text="Approved Loan Summary"
                        id="lsp-summary-title"
                        size="h5"
                      />
                      {customerDetails.source === "upsell" ? (
                        <div id="lsp-approved-summary-detail">
                          <LoanSummaryTextItem
                            title={"Existing Loan Balance"}
                            value={appendRupee(
                              parseInt(
                                customerDetails?.Data?.old_loan_amount
                              ) || 0
                            )}
                          />
                          <LoanSummaryTextItem
                            title={"Top up Loan Amount"}
                            value={appendRupee(
                              parseInt(
                                customerDetails?.Data?.cust_accepted_loan_amount
                              ) || 0
                            )}
                          />
                          <LoanSummaryTextItem
                            title={"Total Loan Amount"}
                            value={appendRupee(
                              parseInt(customerDetails?.Data?.old_loan_amount) +
                                parseInt(
                                  customerDetails?.Data
                                    ?.cust_accepted_loan_amount
                                )
                            )}
                          />
                          <LoanSummaryTextItem
                            title={"New Monthly EMI Amount"}
                            value={appendRupee(
                              parseInt(
                                customerDetails?.Data?.cust_accepted_emi
                              ) || 0
                            )}
                          />
                          <LoanSummaryTextItem
                            title={"Fees & Charges"}
                            value={appendRupee(
                              parseInt(
                                customerDetails?.Data?.processing_fees_amount
                              ) +
                                parseInt(
                                  customerDetails.source === "upsell"
                                    ? customerDetails?.Data?.foreclosure_amount
                                    : 0
                                ) || 0
                            )}
                          />
                          <LoanSummaryTextItem
                            title={"Disbursed Amount"}
                            value={appendRupee(
                              parseInt(
                                customerDetails?.Data?.cust_accepted_loan_amount
                              ) -
                                parseInt(
                                  customerDetails?.Data?.processing_fees_amount
                                ) -
                                parseInt(
                                  customerDetails.source === "upsell"
                                    ? customerDetails?.Data?.foreclosure_amount
                                    : 0 || 0
                                )
                            )}
                          />
                          <LoanSummaryTextItem
                            title={"Application no."}
                            value={
                              customerDetails?.application_form_number ===
                              "None"
                                ? "0"
                                : customerDetails?.application_form_number
                            }
                          />
                          <LoanSummaryTextItem
                            title={"Current Loan A/c No."}
                            value={
                              customerDetails?.Data?.old_loan_account_number ||
                              0
                            }
                          />
                          <LoanSummaryTextItem
                            title={"New Loan Tenure"}
                            value={`${customerDetails?.Data?.tenure === "None"
                                ? "0"
                                : customerDetails?.Data?.tenure
                            } Months`}
                          />
                          <LoanSummaryTextItem
                            title={"New Interest Rate"}
                            value={`${customerDetails?.Data?.roi === "None"
                                ? "0"
                                : customerDetails?.Data?.roi
                            }%`}
                          />
                        </div>
                      ) : (
                        <div id="lsp-approved-summary-detail">
                          <LoanSummaryTextItem
                            title={"Loan Amount"}
                            value={appendRupee(
                              parseInt(
                                customerDetails?.Data?.cust_accepted_loan_amount
                              ) || 0
                            )}
                          />
                          <LoanSummaryTextItem
                            title={"EMI Amount"}
                            value={`${appendRupee(
                              parseInt(
                                customerDetails?.Data?.cust_accepted_emi
                              ) || 0
                            )}`}
                          />
                          <LoanSummaryTextItem
                            title={"Processing Fees"}
                            value={appendRupee(
                              parseInt(
                                customerDetails?.Data?.processing_fees_amount
                              ) || 0
                            )}
                          />
                          {customerDetails?.Data?.cust_ins_choice == "YES" && customerDetails?.source == "epl"? (
                            <LoanSummaryTextItem
                              title={"Insurance Amount"}
                              value={appendRupee(
                                Math.round
                                (parseFloat(
                                    customerDetails?.Data?.emi_protect_ins
                                  ) +
                                    parseFloat(
                                      customerDetails?.Data?.accident_coverage_ins
                                    ) )|| 0
                              )}
                            />
                          ) : (
                            <></>
                          )}
                          {/* <LoanSummaryTextItem
                          title={"Insurance Amount"}
                          value={appendRupee(insuranceAmount)}
                        /> */}
                          <LoanSummaryTextItem
                            title={"Loan Tenure"}
                            value={`${customerDetails?.Data?.tenure === "None"
                                ? "0"
                                : customerDetails?.Data?.tenure
                            } Months`}
                          />
                          <LoanSummaryTextItem
                            title={"Interest Rate"}
                            value={`${customerDetails?.Data?.roi === "None"
                                ? "0"
                                : customerDetails?.Data?.roi
                            }% p.a.`}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
              <div className="downloadButtonsStyle">
                {showShimmer ? (
                  <>
                    <ShimmerPlaceholder
                      height="5em"
                      width="15em"
                      marginTop="20px"
                      visible={showShimmer}
                    />
                    <ShimmerPlaceholder
                      height="5em"
                      width="15em"
                      visible={showShimmer}
                    />
                    <ShimmerPlaceholder
                      height="5em"
                      width="15em"
                      visible={showShimmer}
                    />
                  </>
                ) : (
                  <>
                    <button
                      className="downloadButton"
                      onClick={() => openPDFiFrame("KFS")}
                    >
                      <img src={Pdf_icon} className="download-img " />
                      <span>Key Fact Statement</span>
                    </button>
                    <button
                      className="downloadButton"
                      onClick={() => openPDFiFrame("Sanction_Letter")}
                    >
                      <img src={Pdf_icon} className="download-img " />
                      <span>Sanction Letter</span>
                    </button>
                    <button
                      className="downloadButton"
                      onClick={() => openPDFiFrame("Agreement")}
                    >
                      <img src={Pdf_icon} className="download-img " />
                      <span>Loan Agreement</span>
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
          {showShimmer ? (
            <>
              <ShimmerPlaceholder
                height="2em"
                width="20em"
                marginTop="-0.5em"
                visible={showShimmer}
              />
              <ShimmerPlaceholder
                height="2.5em"
                width="10em"
                visible={showShimmer}
              />
            </>
          ) : (
            <>
              <div className="bottomDiv">
                <CheckField
                  id="la-checkfield"
                  checked={ischecked}
                  label="I agree and accept the terms & conditions of KFS, Sanction Letter and Loan Agreement."
                  style={{
                    fontSize: "1.3rem",
                  }}
                  onClick={() => {
                    handleCheckBox();
                  }}
                />
                <Button
                  id="Btn"
                  className="Btn"
                  mobile={isMobile}
                  disabled={!ischecked}
                  onClick={sendOtp}
                  text={"Send OTP"}
                />
              </div>
            </>
          )}
          <Modal
            open={isOtpSent}
            showCloseButton={false}
            closeonClickOutside={false}
            onClose={() => {
              // setIsOtpSent(false);
            }}
            id="bd-email-otp-parent"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div
                  className="modal-body"
                  style={{ border: "1px solid #A7A7A7", padding: "1rem" }}
                >
                  <div className="pupup-inner">
                    <div className="title text-center">
                      <h2 className="fs-36 font-weight-medium text-black mb-2 lh-1">
                        Loan Agreement Authorization{" "}
                      </h2>
                      <p className="fs-20 font-weight-medium text-black mb-4 pb-2 lh-1">
                        give e-consent by entering OTP
                      </p>
                    </div>
                    <form>
                      <div
                        style={{
                          marginLeft: "10px",
                          marginRight: "10px",
                          marginTop: "15px",
                        }}
                      >
                        <div>
                          <OTPInput
                            length={6}
                            otpDigits={otpDigits}
                            setOtpDigits={setOtpDigits}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          color: "#717171",
                          fontSize: "12px",
                          marginTop: "10px",
                          marginBottom: "10px",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {enableResendOtp ? (
                            <></>
                          ) : (
                            <>
                              <img
                                style={{
                                  height: "15px",
                                  width: "15px",
                                  justifyContent: "center",
                                  marginRight: "4px",
                                }}
                                src={timer}
                              />
                            </>
                          )}
                          <text
                            style={{
                              border: "None",
                              backgroundColor: "white",
                              color: enableResendOtp ? "#3C94FC" : "grey",
                              marginRight: "5px",
                              fontSize: "14px",
                              cursor: "pointer",
                            }}
                            onClick={sendOtp}
                          >
                            Re-send OTP
                          </text>
                        </div>
                        {enableResendOtp ? (
                          <></>
                        ) : (
                          <>
                            <div style={{ fontSize: "14px" }}>
                              in {minutes < 10 ? `0${minutes}` : minutes}:
                              {seconds < 10 ? `0${seconds}` : seconds}
                            </div>
                          </>
                        )}
                      </div>
                      <div className="col-12 col-md-10 col-lg-8 col-xl-8 mx-auto">
                        <div className="col-wrap text-center">
                          <Button
                            id="VerifyOTP"
                            className="Btn VerifyOTP"
                            disabled={!isOtpValid}
                            onClick={
                              // verifyOTP
                              handleVerifyOTPClick
                            }
                            text={"Verify"}
                          />
                        </div>
                      </div>
                      <p style={{ textAlign: "center", paddingTop: "15px" }}>
                        6 digit verification code sent to registered mobile
                        number and will be valid for next 5 minutes.
                      </p>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </LoanAgreementWrapper>
      </AfterLoginLayoutWrapper>
    </>
  );
};

export default LoanAgreement;
